/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { OktaClient } from '../services/OktaClient';

export function showLogin(redirectUrl?: string) {
  return OktaClient.signInWithRedirect({ originalUri: redirectUrl });
}
